import React from 'react';
import loadable from '@loadable/component';
var EnergyLabelA = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelA').then(function (res) { return res.EnergyLabelA; });
});
var EnergyLabelB = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelB').then(function (res) { return res.EnergyLabelB; });
});
var EnergyLabelC = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelC').then(function (res) { return res.EnergyLabelC; });
});
var EnergyLabelD = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelD').then(function (res) { return res.EnergyLabelD; });
});
var EnergyLabelE = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelE').then(function (res) { return res.EnergyLabelE; });
});
var EnergyLabelF = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelF').then(function (res) { return res.EnergyLabelF; });
});
var EnergyLabelG = loadable(function () {
    return import('@lux/zds-icons/lib/EnergyLabelG').then(function (res) { return res.EnergyLabelG; });
});
export var getEnergyIcon = function (energyEfficiencyClass, isPdpDetailsSection) {
    var width = isPdpDetailsSection ? '34px' : '32px';
    var height = isPdpDetailsSection ? '19px' : '17px';
    switch (energyEfficiencyClass) {
        case 'A':
            return React.createElement(EnergyLabelA, { width: width, height: height });
        case 'B':
            return React.createElement(EnergyLabelB, { width: width, height: height });
        case 'C':
            return React.createElement(EnergyLabelC, { width: width, height: height });
        case 'D':
            return React.createElement(EnergyLabelD, { width: width, height: height });
        case 'E':
            return React.createElement(EnergyLabelE, { width: width, height: height });
        case 'F':
            return React.createElement(EnergyLabelF, { width: width, height: height });
        case 'G':
            return React.createElement(EnergyLabelG, { width: width, height: height });
        default:
            return null;
    }
};
